import type { FirewallRule } from '@/entities/firewall';
import request from '@/shared/api/request';

export const createFirewallRule = (
  uuid: string,
  data: { [key: string]: FirewallRule[] },
): Promise<{ [key in 'inbound_rules' | 'outbound_rules']: FirewallRule[] }> =>
  request({
    url: `/firewalls/${uuid}/rules/`,
    method: 'POST',
    data,
  });
